import NavigationStore from "src/store/NavigationStore";

export const stores = {
  navigationStore: new NavigationStore(),
};



// WEBPACK FOOTER //
// ./src/stores.ts